const sentryConfig = {
    environment: import.meta.env.VITE_APP_ENVIRONMENT,
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    release: import.meta.env.SENTRY_RELEASE_NAME,
    dist: import.meta.env.SENTRY_RELEASE_DIST,
} as const;

export default sentryConfig;
